export function selectEnv(dnSalesEnv: string, type: 'URL' | 'VAR' = 'URL') {
    let envPrefix = '';
    switch (dnSalesEnv) {
        case 'local':
            envPrefix = type === 'URL' ? 'dev2.' : 'dev2';
            break;
        case 'dev2':
        case 'dev':
        case 'qa':
        case 'uat': {
            envPrefix = type === 'URL' ? `${dnSalesEnv}.` : `${dnSalesEnv}`;
            break;
        }
        case '':
        case 'production':
        case 'prod': {
            envPrefix = '';
        }
    }
    return envPrefix;
}

export const isProductionEnv = (envName: string) => {
    if (envName === 'prod' || envName === 'sales') {
        return true;
    }

    return false;
};

export function getDsEnvParam(env: string): string {
    const isProdEnv = isProductionEnv(env);
    if (isProdEnv) {
        return '';
    }
    return `&dsEnv=${selectEnv(env, 'VAR')}`;
}
